import { useNavigate } from 'react-router-dom';

export const useMinorInfosPageVM = () => {
    const navigate = useNavigate();

    const handleNextStep = () => {
        navigate('/sante-securite');
    };

    return { handleNextStep };
};
